import axiosInstance from "../../core/axiosConfig.ts";
export class RestaurantItemService {
    async createItem(payload: any) {
        await axiosInstance.post(
            '/menu-item/create',
            payload,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        );
    }

    async updateItem(payload: any) {
        await axiosInstance.patch(
            '/menu-item/update',
            payload,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        );
    }

    async lockUnlockItem(menuItemId: Number) {
        await axiosInstance.patch(
            `/menu-item/item/lock-unlock?menuItemId=${menuItemId}`
        );
    }

    /**
     * Takes an item off the customer menu, or puts it back.
     *
     * Not the same as lockUnlockItem above, which leaves the item on the menu
     * greyed out and unorderable. This removes it from view entirely.
     *
     * Sends the state rather than toggling, unlike lock/unlock: a flip depends
     * on the caller's idea of the current value, and two admins on the same
     * list would fight each other. Saved on its own rather than folded into an
     * update payload - ticking the box is one decision and should take effect,
     * not wait for Save.
     */
    async updateHiddenStatus(menuItemId: number, isHidden: boolean) {
        await axiosInstance.patch(
            '/menu-item/hidden',
            null,
            { params: { menuItemId, isHidden } }
        );
    }

    async getItems(id: number, language: string) {
        const response = await axiosInstance.get(
            '/menu-item/get/admin', { params: { id, language } }
        );
        return response.data;
    }

    async deleteItem(menuItemId: number) {
        const response = await axiosInstance.delete(
            '/menu-item/delete', { params: { menuItemId } }
        );
    }

    async addSuggestedProduct(payload: any) {
        await axiosInstance.patch(
            '/menu-item/suggested-product/update',
            payload
        );
    }
}